/* src/app/@shared/action/action.component.scss */
.edd-del mat-icon {
  cursor: pointer;
  position: relative;
  margin-top: 6px;
  color: #5d6c7c;
}
.edd-del :nth-child(2) {
  margin: 0 16px;
}
/*# sourceMappingURL=action.component.css.map */
